// ============================================================================
// ROLLING HASH - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'rolling-hash',
  name: 'Rolling Hash',
  category: 'Strings',
  complexity: {
    time: 'O(1) per update',
    space: 'O(1)'
  },
  description: 'A hash function that can efficiently compute hash values of substrings in O(1) time after O(N) preprocessing. Uses modular arithmetic to update the hash when sliding a window across the string.'
};
